import { getStatusForId as getStatus } from '@ms/yammer-data-support';
import createCachedSelector from 're-reselect';

import { User, UserNetworkLeader, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('userNetworkLeaders');
export const findByIdThrows = createFindByIdThrows('userNetworkLeaders');

type GetFulfilledUserNetworkLeaders = (state: YammerState) => Record<string, UserNetworkLeader>;
export const getFulfilledUserNetworkLeaders: GetFulfilledUserNetworkLeaders = (state) =>
  state.userNetworkLeaders.fulfilled.byId;

type GetStatusForId = (state: YammerState, userId: User['id']) => ReturnType<typeof getStatus>;
export const getStatusForId: GetStatusForId = (state, userId) => getStatus(state.userNetworkLeaders, userId);

type HasUserNetworkLeaders = (state: YammerState) => boolean;
export const hasUserNetworkLeaders: HasUserNetworkLeaders = createCachedSelector(
  getFulfilledUserNetworkLeaders,
  (fulfilledUserNetworkLeaders) => {
    const userNetworkLeaders = Object.values(fulfilledUserNetworkLeaders).filter(
      (fulfilledUserNetwork) => fulfilledUserNetwork.isLeader
    );

    return !!userNetworkLeaders.length;
  }
)((_state) => 'cache');
